/**
 * Auth constants kept deliberately free of Vite/`import.meta` so they're
 * safe to import from Jest-run code. Anything that needs `import.meta.env`
 * lives in `./auth.js` instead.
 */

/** Paths that must not trigger an Okta redirect. */
export const PUBLIC_PATHS = ['/health'];

/**
 * Return true when `pathname` is public — either an exact match or a
 * subpath of a public prefix.
 */
export function isPublicPath(pathname) {
  return PUBLIC_PATHS.some(
    (p) => pathname === p || pathname.startsWith(p + '/')
  );
}
